import { Button, Group } from "@mantine/core";

import { IconGridFour, IconList } from "@/components/icons";

import type { Dispatch, FC, SetStateAction } from "react";

interface Props {
  carsView: "table" | "cards";
  setCarsView: Dispatch<SetStateAction<"table" | "cards">>;
}

const ViewSwitcher: FC<Props> = ({ carsView, setCarsView }) => {
  return (
    <Group gap="sm">
      <Button
        px="xs"
        onClick={() => setCarsView("cards")}
        variant={carsView === "cards" ? "light" : "subtle"}
      >
        <IconGridFour />
      </Button>
      <Button
        px="xs"
        onClick={() => setCarsView("table")}
        variant={carsView === "table" ? "light" : "subtle"}
      >
        <IconList />
      </Button>
    </Group>
  );
};

export default ViewSwitcher;
